import { useI18nSubscription } from '../../i18n/useI18nSubscription.js';
import { i18n } from '../../../i18n/index.js';
import { Tooltip } from 'antd';
import { EntityStatusChip } from '../../../components/entity-detail/EntityStatusChip.js';
import type { ReactElement } from 'react';

import type { NoteVisibility } from '../api/notes.client.js';

const VISIBILITY_META: Record<NoteVisibility, { labelKey: string; tooltipKey: string }> = {
  workspace: {
    labelKey: 'crm.features.features.notes.components.notesharemodal.метка_всем',
    tooltipKey: 'crm.features.features.notes.components.notesharemodal.подсказка_всем',
  },
  own: {
    labelKey: 'crm.features.features.notes.components.notesharemodal.метка_личное',
    tooltipKey: 'crm.features.features.notes.components.notesharemodal.подсказка_личное',
  },
  shared: {
    labelKey: 'crm.features.features.notes.components.notesharemodal.метка_доступ',
    tooltipKey: 'crm.features.features.notes.components.notesharemodal.подсказка_доступ',
  },
};

/** Индикатор видимости заметки: общий для списка заметок и панелей сущностей. */
export function NoteVisibilityTag({ visibility }: { visibility: NoteVisibility }): ReactElement {
  useI18nSubscription();
  const meta = VISIBILITY_META[visibility] ?? VISIBILITY_META.workspace;
  return (
    <Tooltip title={i18n.t(meta.tooltipKey)}>
      <EntityStatusChip className="ml-2" data-testid={`note-visibility-tag-${visibility}`}>
        {i18n.t(meta.labelKey)}
      </EntityStatusChip>
    </Tooltip>
  );
}
